exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#data-table-domains a {\n  color: #666;\n  text-decoration: none;\n}\n", ""]);

// exports
